import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment.development';

@Injectable({
  providedIn: 'root'
})
export class SearchServiceService {
  private searchTermSource = new BehaviorSubject<string>('');
  currentSearchTerm = this.searchTermSource.asObservable();

    private impressedProducts = new Set<string>();


  constructor(private http:HttpClient) {}

  changeSearchTerm(term: string) {
    this.searchTermSource.next(term);
  }

  clearSearchTerm() {
    this.searchTermSource.next('');
  }

   // ✅ Get product suggestions from backend
  getSuggestions(term: string): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiBaseUrl}/suggestions?query=${encodeURIComponent(term)}`
    );
  }


//impression users product
sendImpressionOnce(productId: string) {
  console.log('product----searapi' , productId)
    // 🔹 Save to localStorage
  this.saveSearchedProductId(productId);

  if (this.impressedProducts.has(productId)) {
    return; // 🚫 duplicate
  }

  this.impressedProducts.add(productId);

  this.http.post(
    `${environment.apiBaseUrl}/impression`,
    { productId }
  ).subscribe();
}

  
saveSearchedProductId(productId: string) {
  const key = 'searchedProducts';

  let ids: string[] = JSON.parse(localStorage.getItem(key) || '[]');

  // ❌ prevent duplicates
  if (ids.includes(productId)) {
    return;
  }

  // add newest to front
  ids.unshift(productId);

  // keep only last 10
  ids = ids.slice(0, 10);

  localStorage.setItem(key, JSON.stringify(ids));

  console.log('Saved searchedProducts -->', ids);
}

}